<div
  class="flex w-fit items-center gap-1 rounded-full border py-0.5 pl-1 pr-2 text-xs"
  [ngClass]="{
    'border-warn-35 bg-warn-95 text-warn-35': isUrgent,
    'border-accent-35 bg-accent-95 text-accent-35': isWarning,
    'border-neutral-35 bg-neutral-95 text-neutral-35': !isUrgent && !isWarning,
  }">
  <mat-icon
    fontIcon="schedule"
    class="material-symbols-outlined qaroni-mat-icon-14" />

  <ng-container i18n>Vence en </ng-container>
  <strong>{{ day() }}</strong>
  <ng-container i18n>días </ng-container>
</div>
